import { format } from "date-fns";

export function parseDateCreareSafe(dataCreare) {
  if (!dataCreare || dataCreare.length !== 12) {
    // console.log('dataCreare.length', dataCreare?.length);
    // console.log('parseDateCreareSafe: invalid input');
    return null; // Return null for invalid input
  }

  const year = parseInt(dataCreare.substring(0, 4), 10);
  const month = parseInt(dataCreare.substring(4, 6), 10) - 1; // Month is 0-based
  const day = parseInt(dataCreare.substring(6, 8), 10);
  const hours = parseInt(dataCreare.substring(8, 10), 10);
  const minutes = parseInt(dataCreare.substring(10, 12), 10);

  if (
    isNaN(year) ||
    isNaN(month) ||
    isNaN(day) ||
    isNaN(hours) ||
    isNaN(minutes)
  ) {
    console.log("parseDateCreareSafe: invalid component values");
    return null; // Return null for invalid component values
  }

  const date = new Date(year, month, day, hours, minutes);

  if (isNaN(date.getTime())) {
    return null; // Return null if the constructed date is invalid
  }

  return date;
}

const formatDate = (x) => {
  try {
    return new Date(x).toLocaleDateString("ro-RO");
  } catch (e) {
    console.log("err #410: ", e, "at formatDate for ", x);
    return x;
  }
};

/**
 * Parses a date string and returns a formatted date.
 * @param dataCreare The date string to parse.
 * @returns The formatted date string, or null if the input is invalid.
 */
export function parseDateCreareSafe2(dataCreare: string): string | null {
  if (!dataCreare || dataCreare.length !== 12) {
    // console.log('dataCreare.length', dataCreare.length);
    // console.log('parseDateCreareSafe: invalid input');
    return null; // Return null for invalid input
  }

  const year = parseInt(dataCreare.substring(0, 4), 10);
  const month = parseInt(dataCreare.substring(4, 6), 10) - 1; // Month is 0-based
  const day = parseInt(dataCreare.substring(6, 8), 10);
  const hours = parseInt(dataCreare.substring(8, 10), 10);
  const minutes = parseInt(dataCreare.substring(10, 12), 10);

  if (
    isNaN(year) ||
    isNaN(month) ||
    isNaN(day) ||
    isNaN(hours) ||
    isNaN(minutes)
  ) {
    console.log("parseDateCreareSafe: invalid component values");
    return null; // Return null for invalid component values
  }

  const date = new Date(year, month, day);

  if (isNaN(date.getTime())) {
    return null; // Return null if the constructed date is invalid
  }

  return formatDate(date);
}

export function parseDateCreareSafe3(dataCreare) {
  if (!dataCreare || dataCreare.length !== 12) {
    // console.log('dataCreare.length', dataCreare.length);
    // console.log('parseDateCreareSafe: invalid input');
    return null; // Return null for invalid input
  }

  const year = parseInt(dataCreare.substring(0, 4), 10);
  const month = parseInt(dataCreare.substring(4, 6), 10) - 1; // Month is 0-based
  const day = parseInt(dataCreare.substring(6, 8), 10);
  const hours = parseInt(dataCreare.substring(8, 10), 10);
  const minutes = parseInt(dataCreare.substring(10, 12), 10);

  if (
    isNaN(year) ||
    isNaN(month) ||
    isNaN(day) ||
    isNaN(hours) ||
    isNaN(minutes)
  ) {
    console.log("parseDateCreareSafe: invalid component values");
    return null; // Return null for invalid component values
  }

  const date = new Date(year, month, day, hours, minutes);

  if (isNaN(date.getTime())) {
    return null; // Return null if the constructed date is invalid
  }

  return format(date, "HH:mm");
}
